// extracted by mini-css-extract-plugin
module.exports = {"loader":"W","smallLoader":"X","loading-keyframes":"Y","pageLoader":"Z","centered":"_","whitespacePlaceholder":"aa","buttonSpinner":"ba","fade-in":"ca","rotate":"da"};